export default __webpack_public_path__ + "static/media/iusd1.3fad127f.png";